{
  "api": {
    "locationValidationTitle": "เราไม่สามารถตรวจสอบตำแหน่งของคุณได้",
    "thresholdTitle": "ไม่อยู่ในช่วงเวลาที่สามารถเช็กอินได้",
    "warehouseUnavailableTitle": "คลังสินค้าไม่พร้อมให้บริการ",
    "warehouseUnavailableMessage": "โปรดติดต่อเจ้าหน้าที่ของสถานที่เพื่อดำเนินการเช็กอินด้วยตนเอง",
    "characterLimitTitle": "ข้อมูลที่ป้อนเกินจำนวนอักขระที่กำหนด",
    "genericTitle": "เช็กอินไม่สำเร็จ โปรดลองอีกครั้ง",
    "recaptchaTitle": "การยืนยันล้มเหลว",
    "recaptchaMessage": "เราไม่สามารถยืนยันคำขอของคุณได้ โปรดลองอีกครั้งหรือติดต่อเจ้าหน้าที่ของสถานที่"
  }
}
